module.exports = __webpack_public_path__ + "static/media/logo.daeb1701.svg";